<template>
    <svg width="80px" height="80px" viewBox="0 0 80 80" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
        <g id="Spinner/Page" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <polygon id="bar-green" class="fill-primary" points="59.2283594 44.9106979 57.2283594 54.5962499 19.5880442 54.5962499 21.8617048 44.9106979"></polygon>
            <polygon id="bar-blue" class="fill-primary-alt" points="59.2283594 26.1107033 57.2283594 35.7962553 19.5880442 35.7962553 21.8617048 26.1107033"></polygon>
        </g>
    </svg>
</template>

<script>
    export default {
        name: 'LoaderHexeko'
    }
</script>

<style>
    #bar-green {
        animation: bar-animation 0.35s infinite ease-in-out;
    }
    #bar-blue {
        animation: bar-animation 0.35s infinite ease-in-out reverse;
    }
    @keyframes bar-animation {
        0% {
            transform: translateX(0px)
        }
        25% {
            transform: translateX(-15px)
        }
        75% {
            transform: translateX(15px)
        }
        100% {
            transform: translateX(0)
        }
    }
</style>